import outline from "../../character-outline-body.png";
import React from "react";
import './CharacterBackground.less'

export function CharacterBackground() {
  return <div
    className='character-background'
    style={{backgroundImage: `url(${outline})`}}
  />;
}